import React from 'react'
import i18n from 'i18next'
import * as R from 'ramda'
import { formatDistance } from 'date-fns'
import { observer } from 'mobx-react'

import Modal from '../../../UniformComponents/Modal'
import Typography from '../../../UniformComponents/Typography'
import Button from '../../../UniformComponents/Button'

const ROW_STYLE = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 12,
    padding: '12px 16px',
    border: '1px solid #CADAE1',
    borderRadius: 8,
    marginBottom: 10,
    cursor: 'pointer',
}

const getTemplateData = (template) => {
    const raw = template?.data
    if (!raw) return null
    if (typeof raw !== 'string') return raw
    try {
        return JSON.parse(raw)
    } catch (e) {
        return null
    }
}

const getTemplateCounts = (template) => {
    const sections = R.pathOr([], ['section'], getTemplateData(template))
    return {
        sectionCount: sections.length,
        slideCount: sections.reduce((total, section) => total + R.pathOr([], ['slide'], section).length, 0),
    }
}

const formatUpdated = (lastUpdated) => {
    if (!lastUpdated) return ''
    try {
        return formatDistance(new Date(`${String(lastUpdated).replace(' ', 'T')}Z`), new Date(), { addSuffix: true })
    } catch (e) {
        return ''
    }
}

const InsertTemplateModal = ({ store }) => {
    const { selectedInsertTemplate, insertableTemplates, insertTemplateMissingQuestions } = store

    return (
        <Modal
            show={store.insertTemplateModalOpen}
            onClose={store.closeInsertTemplateModal}
        >
            <Typography type="h2">{i18n.t('templates.insertModal.title')}</Typography>

            <br />

            <hr />

            <br />

            {!selectedInsertTemplate ? (
                <div>
                    {insertableTemplates.length ? (
                        insertableTemplates.map((template) => {
                            const { slideCount } = getTemplateCounts(template)
                            const updated = formatUpdated(template.updatedAt)
                            const selectTemplate = () => store.selectInsertTemplate(template.uuid)
                            return (
                                <div
                                    key={template.uuid}
                                    className="pp-insert-template-row"
                                    role="button"
                                    tabIndex={0}
                                    onClick={selectTemplate}
                                    onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && selectTemplate()}
                                    style={ROW_STYLE}
                                >
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: 4, width: '100%' }}>
                                        <Typography type="b">{template.title}</Typography>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                                            <div style={{ backgroundColor: '#F7F5FF', borderRadius: '20px', alignItems: 'center', justifyContent: 'center', padding: '4px 10px', display: 'flex', gap: 4, color: '#715AF8' }}>
                                                <i className="fal fa-layer-group" />

                                                <Typography type="tiny-b">
                                                    {`${slideCount} slide(s)`}
                                                </Typography>
                                            </div>
                                            <Typography type="tiny" color="grey">
                                                <i className="fal fa-timer" style={{ marginRight: 4 }} />

                                                {`Updated ${updated}`}
                                            </Typography>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                    ) : (
                        <Typography type="tiny">{i18n.t('templates.insertModal.empty')}</Typography>
                    )}
                </div>
            ) : (
                <div>
                    <Typography type="b">{selectedInsertTemplate.title || selectedInsertTemplate.name}</Typography>

                    <br />

                    {insertTemplateMissingQuestions.length ? (
                        <div style={{ backgroundColor: '#FEF3D9', border: '1px solid #FEB201', borderRadius: 8, padding: '12px 16px', marginTop: 12 }}>
                            <Typography type="b">
                                {i18n.t('templates.insertModal.missingWarning', { count: insertTemplateMissingQuestions.length })}
                            </Typography>

                            <br />

                            <ul>
                                {insertTemplateMissingQuestions.map((label) => (
                                    <li key={label}>
                                        <Typography type="tiny">{label}</Typography>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ) : null}

                    <br />

                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10 }}>
                        <Button
                            label={i18n.t('back')}
                            onClick={store.clearInsertTemplateSelection}
                            cssClass="regular tertiary"
                        />
                        <Button
                            icon="fa-light fa-circle-plus"
                            label={i18n.t('templates.insertModal.submit')}
                            onClick={store.confirmInsertTemplate}
                            cssClass="regular primary"
                        />
                    </div>
                </div>
            )}
        </Modal>
    )
}

export default observer(InsertTemplateModal)
